<template>
    <tr :data-virtual-key="item.key" :class="{'review-grid__total': item.total, selected}">
        <th class="name" scope="row" :title="item.group.name">
            <button v-if="item.group.employee_id" type="button" class="review-grid__link" :aria-label="'Открыть карточку: ' + item.group.name" @click="employee">{{ item.total ? 'Итого · ' : '' }}{{ item.name }}</button>
            <template v-else>{{ item.total ? 'Итого · ' : '' }}{{ item.name }}</template>
        </th>
        <td class="object" :title="item.objectTitle">
            <template v-if="item.total">Все табели<span v-if="item.group.issues.length"> · ⚠ {{ item.group.issues.length }}</span></template>
            <button v-else type="button" class="review-grid__link review-grid__object" :title="item.objectTitle" @click="details">
                <span class="review-grid__object-name">{{ item.objectName }}</span><span class="review-grid__status-label" :class="`status-${item.source.status}`">{{ item.status }}</span>
                <small v-if="item.row.shared_characteristic && item.row.shared_characteristic.comparison && item.row.shared_characteristic.comparison.unchanged_text" class="badge badge-warning">Без изменений с прошлого месяца</small>
            </button>
            <small v-if="archiveWarning" class="d-block text-warning">{{ archiveWarning }}</small>
        </td>
        <td v-for="cell in item.cells" :key="cell.date" class="day" :class="cell.className">
            <button type="button" class="review-grid__cell" :title="cell.title" :aria-label="cell.title" @click="$emit('details', {group: item.group, row: null, date: cell.date})"><span v-for="(token, index) in cell.tokens" :key="index" :class="`review-value-${token.kind}`">{{ token.text }}</span><sup v-if="cell.issue">⚠</sup></button>
        </td>
        <td class="total">
            <button v-if="item.total" type="button" class="review-grid__link" :class="{warning: item.excess}" @click="details">{{ item.daysTotal }}<sup v-if="item.excess">⚠</sup></button>
            <template v-else>{{ item.daysTotal }}</template>
        </td>
        <td class="total">{{ item.hoursTotal }}</td>
        <td v-if="item.total" colspan="2"></td>
        <template v-else>
            <td class="author" :title="item.authorTitle"><small v-if="item.source.author_id" class="d-block text-muted">{{ item.source.author_role === 'editor' ? 'Изменил' : 'Подал' }}</small>{{ item.author }}</td>
            <td class="ktu"><button type="button" class="review-grid__link" @click="details">{{ item.row.ktu == null ? (item.row.category === 'itr' ? 'ИТР · необязательно' : '—') : item.row.ktu }}</button></td>
        </template>
    </tr>
</template>
<script>
import {warnings} from '@/utils/timesheetReviewReport';
export default {
    name: 'TimesheetReviewRow',
    props: {item: Object, selected: Boolean},
    computed: {archiveWarning() { return this.item.row ? warnings(this.item.row) : ''; }},
    methods: {
        details() { this.$emit('details', {group: this.item.group, row: this.item.row, date: ''}); },
        employee() { this.$emit('open-employee', {group: this.item.group, row: this.item.row || this.item.group.rows[0]}); }
    }
};
</script>
